import React, { FC } from 'react';
import UserInfo from '../../../Components/UserInfo/UserInfo';
import Container from '../../../../../Common/Container/Container';
import * as classes from './InfoSection.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import IntroText from '../../../Components/IntoText/IntroText';
import { InfoSectionProps } from '../../../../../Sections/HomePage/InfoSection/InfoSection';

const InfoSection: FC<InfoSectionProps> = ({ aboutText, avatar, email, phone }) => {
  const { t } = useTranslation();

  return (
    <section className={classes.wrapper} data-aos='fade-in'>
      <Container className={classes.container}>
        <div className={'row'}>
          <div className={'col-12 col-md-4 col-lg-3 col-xl-3'}>
            <UserInfo avatar={avatar} phone={phone} email={email} />
          </div>
          <div className={'col-12 col-md-8 col-lg-7 offset-lg-2 col-xl-7 offset-xl-2'}>
            <div className={classes.heading}>
              <span className={classes.number}>01</span>
              <span>{t('homePage.infoSection.introduction')}</span>
            </div>
            <IntroText introText={aboutText} />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default InfoSection;
